module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAS1BMVEUAAABmdX9mdX9mdX9mdX/R09TR09TdLkRmdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX9mdX+8vsBVrO47iMO8vsC8vsC8vsBSRe09AAAAGXRSTlMAYN8A//8A/1CfMI/vIHDPEL+v////31AArsUW6gAAANBJREFUeAHt1M2ugyAQQOEBR6si/rbg+z/ppYnESGxnGtm0d84KFnwLwgB0SmtVkEFBpDSGaAo4DIcCmuFRQDM8CmiGRwHN8CigGR4FbIaggM+kFAGVzKokqJL+BXQ7SaD8ly3vSKDYERCobrhQU7/+/FvTIXIhxM60Z5A1GkN86Jk29gjZfsDQx1Bo6G2ERjXhXskM9yY1BkjNGLoEhWYFSxIXWpJ+HbpvRSju362TcwIJJLMmsyaQzNpXQI+tDJBALg/kwOeBPKzeXYecX/8Awzq+GZnUyuMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f3e3.png
// module id = 811
// module chunks = 0